import './styles.scss';
import { applyPolyfills, defineCustomElements } from '@trellix-ux/components/loader';

applyPolyfills().then(defineCustomElements);
